__turbopack_context__.v({
  "columnSkeleton": "_iavSW_columnSkeleton",
  "dayHeader": "_iavSW_dayHeader",
  "priceTableColumn": "_iavSW_priceTableColumn",
  "priceTableColumnDisabled": "_iavSW_priceTableColumnDisabled",
  "priceTableRoot": "_iavSW_priceTableRoot",
});
